import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import { KPI_NAME_KEY } from '../../../../dashboard-config/kpis/kpi-data-transformers';
import { MetricProfile } from '../../../../dashboard-config/metrics/metric-profile';
import {
  RANKING_MC_VALUE_KEY,
  RANKING_MC_VALUE_PCT_KEY,
  RANKING_MC_VALUE_SUM_KEY,
  RANKING_MC_VALUE_SUM_PCT_KEY,
} from './dashboard-ranking-multi-column.definition';
import {
  RankingMeasure,
  RankingMetricProfile,
  rankingCompaniesCountProfile,
  rankingCompaniesRevenueProfile,
  rankingEconomicParticipantProfile,
  rankingEmployedProfile,
  rankingGrossValueAddedProfile,
} from '../dashboard-ranking/dashboard-ranking-metric.profile';

/**
 * Multi-column (WZ-Klassen) ranking of a metric: a view of its ranking, so heading leads, time,
 * popup and period plumbing come from the ranking metric profile.
 */
export interface RankingMultiColumnMetricProfile {
  metricId: Metric;
  base: MetricProfile;
  ranking: RankingMetricProfile;
  /** Row column overriding the metric's short label when the KPI is the metric itself (GVA). */
  metricLabelKey?: string;
}

/** Value and shares of every row (WZ class × state), plus the Σ sub-market row. */
export const RANKING_MC_CHART_MEASURES: readonly RankingMeasure[] = [
  { measure: 'value', resultColumn: RANKING_MC_VALUE_KEY },
  { measure: 'shareOfCountryPct', resultColumn: RANKING_MC_VALUE_PCT_KEY },
  { measure: 'subMarketValue', resultColumn: RANKING_MC_VALUE_SUM_KEY },
  { measure: 'subMarketShareOfCountryPct', resultColumn: RANKING_MC_VALUE_SUM_PCT_KEY },
];

/** The map (sub-market dataset) shows the share of the Σ sub-market in the pct key. */
export const RANKING_MC_MAP_MEASURES: readonly RankingMeasure[] = [
  { measure: 'value', resultColumn: RANKING_MC_VALUE_KEY },
  { measure: 'shareOfSumSubMarketPct', resultColumn: RANKING_MC_VALUE_PCT_KEY },
];

function multiColumnOf(ranking: RankingMetricProfile, metricLabelKey?: string): RankingMultiColumnMetricProfile {
  return { metricId: ranking.metricId, base: ranking.base, ranking, metricLabelKey };
}

export const rankingMultiColumnCompaniesCountProfile = multiColumnOf(rankingCompaniesCountProfile);
export const rankingMultiColumnCompaniesRevenueProfile = multiColumnOf(rankingCompaniesRevenueProfile);
export const rankingMultiColumnGrossValueAddedProfile = multiColumnOf(rankingGrossValueAddedProfile, KPI_NAME_KEY);
export const rankingMultiColumnEconomicParticipantProfile = multiColumnOf(rankingEconomicParticipantProfile);
export const rankingMultiColumnEmployedProfile = multiColumnOf(rankingEmployedProfile);
